(function () {
  'use strict';

  // Maps a ?ref= value in the URL to the hero H1, subheading, and CTA button
  // copy for that scenario. "default" is used when there is no ref param, or
  // the value doesn't match anything below.
  var REF_CONTENT = {
    picky: {
      h1: 'Tired of buying food your dog refuses? Let them try 3 recipes first.',
      sub: 'Stop guessing what they\'ll eat. Try Classic Chicken, Apple Chicken and Mango Chicken for ₹449 and find what they like before buying more.',
      cta: 'TRY 3 FIRST'
    },
    tummy: {
      h1: 'Is your dog struggling with digestion? Try our Starter Pack risk-free.',
      sub: 'Better digestion starts in the bowl. Guaranteed your dog will love it.',
      cta: 'End Tummy Problems'
    },
    shedding: {
      h1: 'Dog shedding too much? Try our Starter Pack risk-free.',
      sub: 'Healthier skin and coat start in the bowl. Guaranteed your dog will love it.',
      cta: 'Shed Less'
    },
    breath: {
      h1: 'Does your dog have bad breath? Try our Starter Pack risk-free.',
      sub: 'Bad breath isn’t always just about teeth. Guaranteed your dog will love it.',
      cta: 'Stop Bad Breath'
    },
    weight: {
      h1: 'Trying to get your dog to lose weight? Try our Starter Pack risk-free.',
      sub: 'Better weight control starts in the bowl. Guaranteed your dog will love it.',
      cta: 'Get Back In Shape'
    },
    itching: {
      h1: 'Is your dog constantly scratching? Try our Starter Pack risk-free.',
      sub: 'Constant scratching can start with what’s in the bowl. Guaranteed your dog will love it.',
      cta: 'Calm The Itch'
    },
    'home-cooked': {
      h1: 'Is your home-cooked meal balanced? Try our Starter Pack risk-free.',
      sub: 'Home-cooked meals can leave nutrition gaps. Build a more complete bowl. Guaranteed your dog will love it.',
      cta: 'End Nutrition Gaps'
    },
     default: {
      h1: '3 fresh chicken meals. ₹449. Try one pouch first.',
      sub: 'Classic Chicken, Apple Chicken and Mango Chicken. If your dog doesn\'t like it, return or switch the unopened packs. Terms apply.',
      cta: 'START NOW'
    }
  };

  var params = new URLSearchParams(window.location.search);
  var ref = (params.get('ref') || '').trim().toLowerCase();
  var content = REF_CONTENT[ref] || REF_CONTENT.default;

  var heading = document.querySelector('[data-rob-lp-hero-heading]');
  if (heading && content.h1) {
    heading.textContent = content.h1;
  }

  // No "sub" for a scenario (currently just "default") leaves the
  // subheading as whatever's set in the theme editor.
  var subheading = document.querySelector('[data-rob-lp-hero-subheading]');
  if (subheading && content.sub) {
    subheading.textContent = content.sub;
  }

  document.querySelectorAll('[data-rob-lp-cta]').forEach(function (button) {
    if (content.cta) {
      button.textContent = content.cta;
    }
  });

  // "Tap any “_____” button..." in the How do I order? FAQ answer.
  // Richtext settings strip custom attributes, so this is matched by
  // content (the "Tap any" answer) rather than a data attribute.
  document.querySelectorAll('.rob-lp-faq__answer').forEach(function (answer) {
    if (!content.cta || answer.textContent.indexOf('Tap any') === -1) return;
    var quote = answer.querySelector('strong');
    if (quote) {
      quote.textContent = content.cta;
    }
  });

  // The mobile fixed CTA bar (the final-cta section's own button, pinned to
  // the bottom of the screen via CSS) should stay hidden while the hero is
  // in view, then slide up once the hero has scrolled out of view (i.e. the
  // visitor has reached the Six Reasons section).
  var heroSection = document.querySelector('.rob-lp-hero');
  if (heroSection && 'IntersectionObserver' in window) {
    var stickyCtaObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          document.body.classList.toggle('rob-lp-sticky-cta-visible', !entry.isIntersecting);
        });
      },
      { threshold: 0 }
    );
    stickyCtaObserver.observe(heroSection);
  }
})();
